export const VARIANT_CONTEXTUAL = 'variant-contextual';
export const VARIANT_CONTEXTUAL_NOT_ENROLLED = 'variant-contextual-not-enrolled';
